export const config = {
    LOGIN_URL: '/login',
    LOGOUT_URL: '/logout',
    API_URL: 'https://mycontentportal.ci.avalara.io/localization/',
    IXIA_API_URL: 'https://mycontentportal.ci.avalara.io/external-api/',
    AUTH_API_URL: 'https://mycontentportal.ci.avalara.io/authorisation/',
    AUTHORING_DRAFT: 'Authoring:draft',
    AUTHORING_REVIEW: 'Authoring:review',
    AUTHORING_COMPLETE: 'Authoring:complete',
    AUTHORING_DONE: 'Authoring:done',
    OKTAAUTH_ISSUER: 'https://avalara.okta.com/oauth2/default',
    OKTAAUTH_CLIENT_ID: '0oa1li8okhhn17auK1d8',
    OKTAAUTH_REDIRECT_URL: 'https://mycontentportal.ci.avalara.io/login'
  };
  
  